import { Button, Card } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Page } from "../../../../../-components/Page"
import { ScrollContainer } from "../../../../../-components/scroll-container"
import { AddPersonalCalendarProfile } from "../../../../../@client/Theasoft_ApiServer_WebCalendar"
import { WebCalendarProfileDto } from "../../../../../@client/Theasoft_Shared_Contracts_WebCalendar"
import { CalendarStack } from "../-calendar-list"
import { CreateCalendarModal } from "../-create-calendar-modal"
import { EditCalendarProfileModal } from "../-edit-calendar-modal"
import { pathProxy } from "../../../../../utils/forms-proxy"
import { useCanAddPersonalCalender } from "@/orval/gen"
import { useGetAuthenticatedUser } from "@/routes/app/-components/use-authenticated-user"
import { CreateActivityCalendarModal } from "./CreateActivityCalendarModal"
import { useDisclosure } from "@mantine/hooks"
import { UpdateActivityCalendarModal } from "./UpdateActivityCalendarModal"

const addCalendarProfilePathProxy = pathProxy<AddPersonalCalendarProfile>()

export function CalendarSubscriptionsPage() {
  const { t } = useTranslation("app_server")
  const [opened, setOpened] = React.useState(false)
  const [
    activityCalendarModalOpened,
    { open: openActivityCalendarModal, close: closeActivityCalendarModal },
  ] = useDisclosure()
  const [selectedProfile, setSelectedProfile] =
    React.useState<WebCalendarProfileDto | null>(null)
  const { data: authenticatedUser } = useGetAuthenticatedUser()
  const { data: canAdd } = useCanAddPersonalCalender({
    query: { enabled: !!authenticatedUser },
  })

  return (
    <Page
      infoDescription={t("Calendar_Subscriptions_Description")}
      buttonGroupProps={{
        children: canAdd && (
          <>
            <Button size="xs" onClick={() => setOpened(true)}>
              {t("Calendar_Subscriptions_CreatePersonalCalendar")}
            </Button>
            <Button size="xs" onClick={openActivityCalendarModal}>
              {t("Calendar_Subscriptions_CreateActivityCalendar")}
            </Button>
          </>
        ),
      }}
    >
      {canAdd && (
        <>
          <CreateCalendarModal
            onClose={() => {
              setOpened(false)
            }}
            opened={opened}
            addCalendarProfilePathProxy={addCalendarProfilePathProxy}
          />
          <EditCalendarProfileModal
            profileId={
              selectedProfile && !selectedProfile.isActivityCalendar
                ? selectedProfile!.webCalendarProfileId
                : null
            }
            onClose={() => {
              setSelectedProfile(null)
            }}
            addCalendarProfilePathProxy={addCalendarProfilePathProxy}
          />
          <CreateActivityCalendarModal
            opened={activityCalendarModalOpened}
            onClose={closeActivityCalendarModal}
            title={t("Calendar_Subscriptions_CreateActivityCalendar")}
          />
          <UpdateActivityCalendarModal
            opened={!!selectedProfile?.isActivityCalendar}
            profileId={selectedProfile?.webCalendarProfileId}
            onClose={() => setSelectedProfile(null)}
          />
        </>
      )}

      <Card mt="md">
        <ScrollContainer>
          <CalendarStack onEditProfileClick={setSelectedProfile} />
        </ScrollContainer>
      </Card>
    </Page>
  )
}
